import { render } from "./RealtimeQuote.vue?vue&type=template&id=54d1cadf&ts=true"
import script from "./RealtimeQuote.vue?vue&type=script&lang=ts"
export * from "./RealtimeQuote.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__